module.exports = __webpack_public_path__ + "img/flag-sw.54096c92.svg";